import ApiBase, { baseUrl } from '.';
import qs from 'qs';

export default class MediaApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/Report`, token);
  }

  getCourseResultReport(params) {
    return this.authHttp.get(`${this.baseUrl}/GetCourseResultReport`, {
      responseType: 'blob',
      params: { courseIds: params.courseIds, groupIds: params.groupIds },
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    });
  }
}
